import { Col, Row, Space, Divider, Button, Form, Select, message, Typography, Input, Tooltip } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { UserOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Anexos } from "../anexos";
import dayjs from "dayjs";
import { AuthContext } from "../../../../../contexts/AuthContext";
import http from "../../../../../services/http";
const { Text, Paragraph } = Typography;

const options_status = [
  {
    value: -1,
    label: (
      <Text style={{ color: "#df6d06cc" }}>
        <ClockCircleOutlined /> Aguardando
      </Text>
    ),
    disabled: true,
  },
  {
    value: 1,
    label: (
      <Text style={{ color: "#60b565" }}>
        <CheckCircleOutlined /> Alcançado
      </Text>
    ),
  },
  {
    value: 2,
    label: (
      <Text style={{ color: "#2e5b00cc" }}>
        <CheckCircleOutlined /> Alcançado parcial
      </Text>
    ),
  },
  {
    value: 4,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <CloseCircleOutlined /> Não alcançado
      </Text>
    ),
  },
  {
    value: 3,
    label: (
      <Text style={{ color: "#1677ff" }}>
        <ClockCircleOutlined /> Em andamento
      </Text>
    ),
  },
  {
    value: 0,
    label: (
      <Text type="secondary">
        <CloseCircleOutlined /> Cancelado
      </Text>
    ),
  },
];

export const Problema = ({ problema, loadingData, alterarStatus }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { session } = useContext(AuthContext);
  const [avaliadores, setAvaliadores] = useState([]);
  const [responsaveis, setResponsaveis] = useState([]);

  useEffect(() => {
    if (problema?.id > 0) {
      form.setFieldsValue({ status: problema?.status, observacoes: problema?.observacoes ?? "" });
    }
  }, [problema]);

  useEffect(() => {
    if (problema?.id_grupo_avaliadores > 0) {
      listarColaboradoresAvaliadores(problema?.id_grupo_avaliadores);
    }
  }, [problema?.id_grupo_avaliadores]);

  useEffect(() => {
    if (problema?.id_sistemas_origens > 0) {
      listarColaboradoresResponsaveis(problema?.id_sistemas_origens);
    }
  }, [problema?.id_sistemas_origens]);

  const listarColaboradoresAvaliadores = async (id = 0) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_grupo_avaliadores/listar_colaboradores/${id}`, []);
    if (api.statusCode === 200) {
      setAvaliadores(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const listarColaboradoresResponsaveis = async (id = 0) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_sistemas_origens/listar_colaboradores/${id}`, []);
    if (api.statusCode === 200) {
      setResponsaveis(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const onSubmitForm = (values) => {
    const formulario = {
      id: problema?.id,
      status: values?.status,
      observacoes: values?.observacoes,
    };
    alterarStatus(formulario);
  };

  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text strong style={{ fontSize: 16 }}>
            {descricao ?? "-"}
          </Text>
        </Space>
      </Col>
    );
  };

  return (
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <RenderItem
        titulo="Filial/Setor (Onde?)"
        descricao={
          problema?.setor ?? (
            <Text type="secondary" italic>
              Individual
            </Text>
          )
        }
      />
      <RenderItem titulo="Responsável (Quem?)" descricao={problema?.colaborador ?? "-"} />
      <RenderItem
        titulo="Grupo/Usuário Avaliador"
        descricao={
          problema?.grupo_avaliador ? (
            <>
              {problema?.grupo_avaliador}{" "}
              <Tooltip
                title={
                  <Paragraph
                    ellipsis={{ rows: 10, suffix: avaliadores?.length >= 11 && "mais " + (avaliadores?.length - 10) }}
                    className="fontSmall white-text">
                    {avaliadores?.map((e) => (
                      <div key={e?.id}>
                        {e?.nome}
                        <br />
                      </div>
                    ))}
                  </Paragraph>
                }>
                <Button type="text" icon={<UserOutlined />} />
              </Tooltip>
            </>
          ) : (
            <Text type="secondary" italic>
              Sem avaliadores{" "}
            </Text>
          )
        }
      />
      <RenderItem
        titulo="Grupo Origem"
        descricao={
          <>
            {problema?.sistema}{" "}
            <Tooltip
              title={
                <Paragraph
                  ellipsis={{ rows: 10, suffix: responsaveis?.length >= 11 && "mais " + (responsaveis?.length - 10) }}
                  className="fontSmall white-text">
                  {responsaveis?.map((e) => (
                    <div key={e?.id}>
                      {e?.nome}
                      <br />
                    </div>
                  ))}{" "}
                </Paragraph>
              }>
              <Button type="text" icon={<UserOutlined />} />
            </Tooltip>
          </>
        }
      />
      <RenderItem titulo="Usuário Apontador" descricao={problema?.colaborador_abertura ?? "-"} />
      <RenderItem titulo="Data Lançamento" descricao={dayjs(problema?.data_lancamento).format("DD/MM/YYYY") ?? "-"} />

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Space direction="vertical">
          <Text style={{ fontSize: 18, color: "#60b565" }} strong>
            Apontamento (O que?)
          </Text>
          <Text className="line-break">{problema?.oque}</Text>
        </Space>
      </Col>

      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Space direction="vertical">
          <Text style={{ fontSize: 18, color: "#60b565" }} strong>
            Motivo (Por quê?)
          </Text>
          <Text className="line-break">{problema?.porque ?? "-"}</Text>
        </Space>
      </Col>

      <Divider />

      <Form onFinish={onSubmitForm} form={form} autoComplete="off" className="full-width">
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            Status
          </Text>
          <Form.Item name="status" style={{ flexGrow: 1 }} rules={[{ required: true, message: "Selecione o status!" }]}>
            <Select
              placeholder="Selecione o status"
              size="large"
              options={options_status}
              disabled={
                loading ||
                loadingData ||
                (!problema?.avaliadores?.includes(session?.usuario?.id_colaborador) ? true : false) ||
                !problema?.id_colaborador_atendente > 0
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            Observações
          </Text>
          <Form.Item name="observacoes">
            <Input.TextArea
              size="large"
              autoSize={{ minRows: 4, maxRows: 5 }}
              placeholder="Informe as observações"
              disabled={
                loading ||
                loadingData ||
                (!problema?.avaliadores?.includes(session?.usuario?.id_colaborador) ? true : false) ||
                !problema?.id_colaborador_atendente > 0
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Button
            size="large"
            block
            loading={loading || loadingData}
            disabled={
              !problema?.avaliadores?.includes(session?.usuario?.id_colaborador) ||
              !problema?.id_colaborador_atendente > 0
                ? true
                : false
            }
            icon={<CheckCircleOutlined />}
            htmlType="submit">
            Salvar
          </Button>
        </Col>
      </Form>

      <Col span={24}>
        <Divider />
        <Anexos
          id={problema?.id}
          dataLoading={loading || loadingData}
          editable={
            problema?.avaliadores?.includes(session?.usuario?.id_colaborador) && [-1, 3].includes(problema?.status)
              ? true
              : false
          }
        />
      </Col>
    </Row>
  );
};
